import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=ea50a3dc&scoped=true"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea50a3dc",
  null
  
)

export default component.exports